<script setup>
import { computed } from 'vue'
import { searchFilters } from '@/constants'
import { isSearchInventoryEnabled } from '@/helpers/featureFlags'

defineEmits(['select'])

// "Inventory" only appears when the response can actually carry inventory hits.
const filters = computed(() => searchFilters(isSearchInventoryEnabled()))
</script>

<template>
  <section class="py-3 px-4 border-b">
    <h3 class="font-semibold text-gray-400 mb-2">Add filters:</h3>
    <ul class="flex items-center gap-x-3">
      <li
        class="rounded-sm bg-blue-100 py-0.5 px-1 cursor-pointer"
        v-for="(option, index) in filters"
        :key="index"
        v-text="option"
        @click="$emit('select', option)"
      />
    </ul>
  </section>
</template>
